export default {
  title: "Мій профіль",
  dropdown: {
    edit: "Редагувати",
  },
  message: "If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual.",
  about: {
    title: 'Профіль',
    name: {
      label: "Ім'я",
    },
    email: {
      label: "Email",
    },
    time_zone: {
      label: "Часовий пояс",
    },
  },
}
